import { Component, OnInit } from '@angular/core';
import { QUIENESSOMOS } from '../../interfaces/quienes-somos.interface';
import { QuienesSomosService } from '../../services/quienes-somos.service';
import { quienesSomosJson } from './quienes-somos.json';

import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, Title } from '@angular/platform-browser';
import { forkJoin } from 'rxjs';
@Component({
  selector: 'app-quienes-somos',
  templateUrl: './quienes-somos.component.html',
  styleUrls: ['./quienes-somos.component.css']
})
export class QuienesSomosComponent implements OnInit {

  quienesSomosData: any;
  isDataLoaded: boolean = false;

  constructor(
    private quienesSomosService: QuienesSomosService,
    private route: ActivatedRoute,
    private router: Router,
    private sanitizer: DomSanitizer,
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false; // Can reload the page
    this.route.params.subscribe(params => {
    });
    this.quienesSomosService.getQuienesSomos().subscribe(
      (resp) => {
        this.quienesSomosData = resp.data;
        this.quienesSomosData.ParallaxQuienesSomos_props.imgSrc = "https://" + this.quienesSomosData.ParallaxQuienesSomos_props.imgSrc;

        this.isDataLoaded = true;
      },
      (error) => {
        this.quienesSomosData = quienesSomosJson;
        console.log('Error:', error);
      }
    )
  }
  public safeURL(value: any): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }
  ngOnInit(): void {
    // menu sticky
    window.onscroll = function () {
      var nav = document.getElementById('header');
      if (window.pageYOffset > 200) {
        nav!.classList.add("sticky");
      } else {
        nav!.classList.remove("sticky");
      }
    }
  }

  get backgroundImageUrl() {
    return `url(${this.quienesSomosData.ParallaxQuienesSomos_props.imgSrc})`;
  }

}
